<div class="flex flex-col items-center bg-white rounded-[14px] p-[50px] min-h-[520px] w-full">
  <ng-content></ng-content>
</div>
